module.exports = __webpack_public_path__ + "static/media/mastercard_logo.dd761f6a.png";